import { render, staticRenderFns } from "./faka-add.vue?vue&type=template&id=9086e66c&scoped=true"
import script from "./faka-add.vue?vue&type=script&lang=js"
export * from "./faka-add.vue?vue&type=script&lang=js"
import style0 from "./faka-add.vue?vue&type=style&index=0&id=9086e66c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9086e66c",
  null
  
)

export default component.exports